// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QH-z","twoColumnImage":"RH-z"};